import script from "./LaputaBook.vue?vue&type=script&setup=true&lang=js"
export * from "./LaputaBook.vue?vue&type=script&setup=true&lang=js"

import "./LaputaBook.vue?vue&type=style&index=0&id=69cea134&scoped=true&lang=css"

import exportComponent from "../../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['__scopeId',"data-v-69cea134"]])

export default __exports__